var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19421_29962)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 15.5,
    rx: 15.5,
    ry: 15.5,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 10 39)",
    fill: "#50C0CF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8357 23.7187L21.2818 17.1263C20.7245 16.6398 20.7245 15.8512 21.2818 15.3648C21.8392 14.8784 22.7428 14.8784 23.3002 15.3648L31.8632 22.838C32.4206 23.3244 32.4206 24.1131 31.8632 24.5995L23.3002 32.0727C22.7428 32.5591 21.8392 32.5591 21.2818 32.0727C20.7245 31.5863 20.7245 30.7976 21.2818 30.3112L28.8357 23.7187Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19421_29962",
    x: 0,
    y: 0,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19421_29962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19421_29962",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRightArrowIcon);
export default __webpack_public_path__ + "static/media/circle-right-arrow-icon.e00e9896694b20429e580b50b897ffb3.svg";
export { ForwardRef as ReactComponent };